module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAABIklEQVQoU3XQPUvDUBTG8f9JaRGkIHUTBDcVEexNKgqOooM6CnUXit/A1VHwA3Rx101QUXDooig2L24u7k6ia1t6jyTpmxrPlnN/HPI8QmDmUbkCLoATvOCdjJFkF5ZXsc4DyidIlYp/99umMJ6mqSNSA23h6Bom8kfxEPruHPCaPuobl+EsR9g+HsLkqvuBUEqt3acSnWZD3zyCrPSuBnih9w904/RbPajkbInyy1f8LTRmxihOOrQLSr51jsjOIITKLp38NYW2CE1zg8h6/FdA/mctakG6KF2hsTRBMXcPLGQVnRxQ2U5TP1emcewTMPUX2wO8qD7a4yJonHp8gC3HLAeHaZjRCcwmKrfJSvQMN9zLrifeBqaGShXYwAs6ffgNtfFZVsxOpIkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/energy/down.png
// module id = oXAL
// module chunks = 3